import { useEffect, useState } from "react";
import { apiRequest } from "@/network/apiClient";
import { API_ENDPOINTS } from "../apiEndpoints";

export const useLeadJourneyAddInfo = ({leadID}) => {
    const [companyWebsite, setCompanyWebsiteLink] = useState("");
    const [companyRegNo, setCompanyRegNo] = useState("");
    const [addRemarksComp, setAddRemarksComp] = useState("");
    const [addRemarksFarmer, setAddRemarksFarmer] = useState("");
    const [addPurposeOfMM, setAddPurposeOfMM] = useState("");
    const [accID,setAccID] = useState("");

    const fetchData = async () => {
        try{
            const queryParams = new URLSearchParams({
                lead_id: leadID.toString(),
            });

            const result = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.GET_LEADS.ADDITIONAL_INFO}?${queryParams.toString()}`,'GET');
            setCompanyRegNo(result?.company_registration_no);
            setCompanyWebsiteLink(result?.company_website);
            setAddRemarksComp(result?.compliance_remark);
            setAddRemarksFarmer(result?.farmer_remark);
            setAccID(result?.mm_acc_id);
            setAddPurposeOfMM(result?.purpose_of_mm);
        }catch(error){
            console.error("Error fetching data: ", error)
        }
    };

    useEffect(() => {
        fetchData();
    }, [leadID]);

    return {companyRegNo, companyWebsite, addRemarksComp, addRemarksFarmer, addPurposeOfMM, accID, refetch: fetchData}
}